import { getApiUrl, AXIOS_AUTHED } from './shared';

const getLineItemsByCustomer = (
  params = {
    branchId: null,
    routeNumber: null,
    customerId: null,
    active: null
  }
) => {
  return AXIOS_AUTHED.get(
    `${getApiUrl()}/branches/${params.branchId}/routes/${params.routeNumber}/customers/${params.customerId}/customer-products`
  );
};

export { getLineItemsByCustomer };
